<template>
    <div class="first">
        <div class="close_top" @click="close = !close">
            <div>
                <h3>{{ $t('offer.title_photo_title') }}</h3>
                <p>
                    {{ $t('offer.title_photo_hint') }}
                </p>
            </div>
            <div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="28"
                    viewBox="0 0 27 28"
                    fill="none"
                    :class="close ? 'rotate' : ''"
                >
                    <path
                        d="M21.2543 10.9573L13.48 18.8206L5.70562 10.9573"
                        stroke="#263544"
                        stroke-width="0.699172"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
        </div>
        <div v-show="!close" class="close_bottom">
            <form
                action=""
                method="post"
                enctype="multipart/form-data"
                class="offer_title_photo mt-4"
            >
                <input
                    type="file"
                    name="files"
                    class="files"
                    :data-fileuploader-files="preloadedoffertitlephoto"
                />
            </form>
            <div class="overlay-toggle-row mt-3">
                <label class="overlay-toggle-label">
                    <input
                        type="checkbox"
                        class="toggle"
                        v-model="localHideDesktop"
                        @change="emitOverlay"
                    />
                    <span>{{ $t('offer.hide_name_desktop') }}</span>
                    <span class="overlay-info">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="16" x2="12" y2="12" />
                            <line x1="12" y1="8" x2="12.01" y2="8" />
                        </svg>
                        <span class="my_tooltip"
                            >{{ $t('offer.hide_name_desktop_hint') }}
                            textom.</span
                        >
                    </span>
                </label>
            </div>
            <form
                action=""
                method="post"
                enctype="multipart/form-data"
                class="offer_title_photo_mobile mt-4"
            >
                <input
                    type="file"
                    name="files_mobile"
                    class="files"
                    :data-fileuploader-files="preloadedoffertitlephoto_mobile"
                />
            </form>
            <div class="overlay-toggle-row mt-3">
                <label class="overlay-toggle-label">
                    <input
                        type="checkbox"
                        class="toggle"
                        v-model="localHideMobile"
                        @change="emitOverlay"
                    />
                    <span>{{ $t('offer.hide_name_mobile') }}</span>
                    <span class="overlay-info">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="16" x2="12" y2="12" />
                            <line x1="12" y1="8" x2="12.01" y2="8" />
                        </svg>
                        <span class="my_tooltip"
                            >{{ $t('offer.hide_name_desktop_hint') }}
                            textom.</span
                        >
                    </span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        "preloadedoffertitlephoto",
        "preloadedoffertitlephoto_mobile",
        "uuidOffer",
        "overlayDesktop",
        "overlayMobile",
    ],
    data() {
        return {
            files: [],
            close: false,
            localHideDesktop: false,
            localHideMobile: false,
        };
    },
    methods: {
        emitOverlay() {
            this.$emit("overlay-changed", {
                desktop: !this.localHideDesktop,
                mobile: !this.localHideMobile,
            });
        },
    },
    created() {
        this.localHideDesktop =
            this.overlayDesktop !== undefined ? !this.overlayDesktop : false;
        this.localHideMobile =
            this.overlayMobile !== undefined ? !this.overlayMobile : false;

        if (this.preloadedoffertitlephoto == "[]") {
            if (this.preloadedoffertitlephoto_mobile == "[]") {
                this.close = true;
            }
        }
        if (this.preloadedoffertitlephoto == "") {
            if (this.preloadedoffertitlephoto_mobile == "") {
                this.close = true;
            }
        }
        if (this.preloadedoffertitlephoto == undefined) {
            if (this.preloadedoffertitlephoto_mobile == undefined) {
                this.close = true;
            }
        }
        var t = this;
        $(document).ready(function () {
            $.ajaxSetup({
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                        "content"
                    ),
                },
            });
            $(".offer_title_photo_mobile input.files").fileuploader({
                limit: 1,
                extensions: ["jpeg", "jpg", "png", "svg"],
                fileMaxSize: 2,
                changeInput:
                    '<div class="fileuploader-input">' +
                    t.$t('offer.title_photo_mobile_label') +
                    '<div class="fileuploader-input-inner">' +
                    '<div class="fileuploader-icon-main"></div>' +
                    '<h3 class="fileuploader-input-caption"><span>${captions.feedback}</span></h3>' +
                    "<p>${captions.or}</p>" +
                    "</div>" +
                    "</div>",
                theme: "dragdrop",
                thumbnails: {
                    onImageLoaded: function (item) {
                        if (item.appended) {
                            t.files.push(item);
                        } else {
                            item.html
                                .find(".column-title span")
                                .html(t.$t('offer.uploading'));
                            const fd = new FormData();
                            fd.append("file", item.file);
                            fd.append("offer_uuid", t.uuidOffer);
                            fd.append("mobile_version", 1);
                            axios
                                .post("/api/offers/offer/homeSystem/upload", fd)
                                .then((response) => {
                                    item.html
                                        .find(".column-title span")
                                        .html(item.size2);
                                    t.files.push(item);
                                });
                        }
                    },
                },
                editor: {
                    cropper: {
                        showGrid: true,
                    },
                },
                captions: $.extend(
                    true,
                    {},
                    $.fn.fileuploader.languages["en"],
                    {
                        feedback:
                            t.$t('offer.upload_img_feedback'),
                        feedback2:
                            t.$t('offer.upload_img_feedback'),
                        drop: t.$t('offer.upload_img_feedback'),
                        or: "",
                        button: "",
                        remove: t.$t('offer.img_remove'),
                        download: t.$t('offer.img_download'),
                        removeConfirmation: t.$t('offer.img_remove_confirm'),
                        errors: {
                            filesLimit: function (e) {
                                t.$toast.warning(
                                    t.$t('offer.img_only_one'),
                                    {
                                        timeout: 5000,
                                    }
                                );
                            },
                            filesType: function (e) {
                                t.$toast.warning(
                                    t.$t('offer.img_invalid_type'),
                                    {
                                        timeout: 5000,
                                    }
                                );
                            },
                            fileSize: function (e) {
                                t.$toast.warning(
                                    e.name +
                                        " je príliš velký! Prosím, výberte obrázok do velikosti " +
                                        e.fileMaxSize +
                                        " MB.",
                                    {
                                        timeout: 5000,
                                    }
                                );
                            },
                        },
                    }
                ),
                onRemove: function (item) {
                    item.html.find(".column-title span").html("Odstranenie...");
                    if (item.appended) {
                        axios
                            .post("/api/offers/offer/homeSystem/remove", {
                                item: item,
                                offer_uuid: t.uuidOffer,
                                mobile_version: 1,
                            })
                            .then((response) => {
                                t.file = null;
                            });
                    } else {
                        const fd = new FormData();
                        fd.append("file", item.file);
                        fd.append("offer_uuid", t.uuidOffer);
                        fd.append("mobile_version", 1);
                        axios
                            .post("/api/offers/offer/homeSystem/remove", fd)
                            .then((response) => {
                                t.file = null;
                            });
                    }
                },
            });
            $(".offer_title_photo input.files").fileuploader({
                limit: 1,
                extensions: ["jpeg", "jpg", "png", "svg"],
                fileMaxSize: 2,
                changeInput:
                    '<div class="fileuploader-input">' +
                    '<span class="top_left">Titulná fotka</span>' +
                    '<div class="fileuploader-input-inner">' +
                    '<div class="fileuploader-icon-main"></div>' +
                    '<h3 class="fileuploader-input-caption"><span>${captions.feedback}</span></h3>' +
                    "<p>${captions.or}</p>" +
                    "</div>" +
                    "</div>",
                theme: "dragdrop",
                thumbnails: {
                    onImageLoaded: function (item) {
                        if (item.appended) {
                            t.files.push(item);
                        } else {
                            item.html
                                .find(".column-title span")
                                .html(t.$t('offer.uploading'));
                            const fd = new FormData();
                            fd.append("file", item.file);
                            fd.append("offer_uuid", t.uuidOffer);
                            fd.append("mobile_version", 0);
                            axios
                                .post("/api/offers/offer/homeSystem/upload", fd)
                                .then((response) => {
                                    item.html
                                        .find(".column-title span")
                                        .html(item.size2);
                                    t.files.push(item);
                                });
                        }
                    },
                },
                editor: {
                    cropper: {
                        showGrid: true,
                    },
                },
                captions: $.extend(
                    true,
                    {},
                    $.fn.fileuploader.languages["en"],
                    {
                        feedback:
                            t.$t('offer.upload_img_feedback'),
                        feedback2:
                            t.$t('offer.upload_img_feedback'),
                        drop: t.$t('offer.upload_img_feedback'),
                        or: "",
                        button: "",
                        remove: t.$t('offer.img_remove'),
                        download: t.$t('offer.img_download'),
                        removeConfirmation: t.$t('offer.img_remove_confirm'),
                        errors: {
                            filesLimit: function (e) {
                                t.$toast.warning(
                                    t.$t('offer.img_only_one'),
                                    {
                                        timeout: 5000,
                                    }
                                );
                            },
                            filesType: function (e) {
                                t.$toast.warning(
                                    t.$t('offer.img_invalid_type'),
                                    {
                                        timeout: 5000,
                                    }
                                );
                            },
                            fileSize: function (e) {
                                t.$toast.warning(
                                    e.name +
                                        " je príliš velký! Prosím, výberte obrázok do velikosti " +
                                        e.fileMaxSize +
                                        " MB.",
                                    {
                                        timeout: 5000,
                                    }
                                );
                            },
                        },
                    }
                ),
                onRemove: function (item) {
                    item.html.find(".column-title span").html("Odstranenie...");
                    if (item.appended) {
                        axios
                            .post("/api/offers/offer/homeSystem/remove", {
                                item: item,
                                offer_uuid: t.uuidOffer,
                                mobile_version: 0,
                            })
                            .then((response) => {
                                t.file = null;
                            });
                    } else {
                        const fd = new FormData();
                        fd.append("file", item.file);
                        fd.append("offer_uuid", t.uuidOffer);
                        fd.append("mobile_version", 0);
                        axios
                            .post("/api/offers/offer/homeSystem/remove", fd)
                            .then((response) => {
                                t.file = null;
                            });
                    }
                },
            });
        });
    },
};
</script>

<style lang="scss">
.offer_title_photo,
.offer_title_photo_mobile {
    .fileuploader {
        background: transparent;
        margin: 0;
        padding: 0;
    }
    .fileuploader-theme-dragdrop .fileuploader-input {
        position: relative;
        border: 1px dashed #dde3e8;
        padding: 15px;
        height: 91px;
        @media (max-width: 600px) {
            height: 110px !important;
            .fileuploader-input-caption {
                flex: 1 !important;
            }
        }
        .top_left {
            position: absolute;
            left: 15px;
            top: 15px;
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 11px;
            line-height: 13px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #9598a7;
        }
        .fileuploader-input-inner {
            margin-top: 14px;
            height: 100%;
            display: flex;
            align-items: center;
        }
    }
    .fileuploader-theme-dragdrop .fileuploader-input .fileuploader-icon-main {
        margin: 0;
        font-size: 32px;
    }
    h3.fileuploader-input-caption {
        margin: 0;
        display: block;
        flex: none;
        align-self: center;
        margin-left: 10px;
        font-family: Roboto;
        font-style: normal;
        font-size: 14px;
        line-height: 16px;
        span {
            font-weight: normal;
            color: #263544;
        }
        .nahraj {
            font-weight: 600;
            color: #2ed8b6;
            text-decoration: underline;
        }
    }
}
</style>
<style lang="scss" scoped>
.close_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    svg {
        transition: all 0.2s;
        cursor: pointer;
        transform: rotate(-90deg);
    }
    svg.rotate {
        transform: rotate(0deg);
    }
}
.close_bottom {
    transition: all 0.5s;
    padding-bottom: 5px;
}
.first {
    width: 100%;
    padding: 17px 20px;
    background: #ffffff;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    margin: 20px 0;
    .textarea {
        border: 1px solid #dde3e8;
        border-radius: 0;
        textarea {
            border: none !important;
            border-top: 25px solid transparent !important;
            padding-top: 0;
            width: 100%;
            height: 120px;
            background: #ffffff;
            box-sizing: border-box;
        }
    }
    .dateInput {
        display: grid;
    }
    .dateInput .mx-input {
        box-shadow: none !important;
        -webkit-box-shadow: none !important;
    }
    .dateInput .mx-datepicker {
        width: 100% !important;
    }
    .dateInput path {
        fill: #383c4c !important;
    }
}
.noPremium {
    margin-top: 15px;
    border-radius: 20px;
    position: relative;
    width: 526px;
    @media screen and (max-width: 700px) {
        width: auto;
    }
    position: relative;
    border: 1px dashed #dde3e8;
    padding: 15px;
    height: 100px;
    .top_left {
        position: absolute;
        left: 10px;
        top: 9px;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #9598a7;
    }
    .ColorBox {
        position: absolute;
        top: 16px;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 510px;
        height: 41px;
        background: #fff7ed;
        border: 1px solid #fbbf24;
        box-sizing: border-box;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        @media screen and (max-width: 700px) {
            width: auto;
            height: fit-content;
            padding: 5px;
        }
        svg {
            width: 21px;
            height: 14px;
            margin-right: 13px;
        }
        div {
            font-family: Roboto;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 19px;
            color: #9a3412;
            b {
                font-weight: 600;
            }
            a {
                font-weight: 600;
                text-decoration: underline;
                color: #9a3412;
                &:hover {
                    color: #9a3412;
                    text-decoration: underline;
                }
            }
        }
    }
}
form {
    width: 600px;
    @media only screen and (max-width: 1000px) {
        width: 95%;
    }
    @media (max-width: 600px) {
        width: 100%;
    }
}
.overlay-toggle-row {
    display: flex;
    align-items: center;
    width: 600px;
    @media only screen and (max-width: 1000px) {
        width: 95%;
    }
    @media (max-width: 600px) {
        width: 100%;
    }
}
.overlay-info {
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: help;
    color: #9598a7;
    &:hover .my_tooltip {
        opacity: 1;
    }
    .my_tooltip {
        bottom: 26px;
        right: -8px;
        width: 240px;
        font-weight: 400;
        font-size: 13px;
        line-height: 1.4;
    }
}
.overlay-toggle-label {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #263544;
    margin: 0;
    span {
        @media (max-width: 600px) {
            width: auto;
        }
    }
}
.form-floating {
    margin-top: 20px;
}
h3 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #212541;
}
p {
    margin-top: 7px;
    margin-bottom: 0px;
    width: 700px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;

    color: #9598a7;
    @media only screen and (max-width: 1000px) {
        width: 95%;
    }
}
.form-floating > label {
    padding: 22px 13px;

    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #9598a7;
}
input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;

    color: #212541;

    border: 1px solid #dde3e8;
    border-radius: 0;
}
label {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #212541;
}
input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    margin: 0px 10px 0 0px;
    background: #c7d4eb;
    border-radius: 25px;
}
.toggle label {
    @media (max-width: 600px) {
        width: 70%;
    }
}
.toggle {
    height: 22px;
    width: 40px;
    display: inline-block;
    position: relative;
    margin: 0;
    border: none;
    background: #ffffff;
    border-radius: 3px;
    transition: all 0.2s ease;
    &:focus {
        outline: 0;
    }
    &:after {
        content: "";
        position: absolute;
        top: 4px;
        left: 3px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: white;
        box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
        transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
    }
    &:checked {
        border-color: #2ed8b6;
        background: #2ed8b6;
    }
    &:checked:after {
        transform: translatex(20px);
    }
}
.mobile_doba_inputs {
    display: grid !important;
}
.doba_inputs {
    background: white;
    padding: 20px;
    width: 100%;
    @media (max-width: 550px) {
        margin: 20px 0 !important;
    }
    .form-floating > label,
    .float-container label {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #9598a7;
    }
    input {
        height: 50px;
        border-radius: 0;
    }
    textarea {
        border-radius: 0;
    }
}
.info {
    position: relative;
    height: 20px;
    margin-left: 10px;
    .info_icon {
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;
        img {
            width: 80%;
            height: 80%;
        }
    }
    .my_tooltip {
        bottom: 22px;
        right: -7px;
    }
}
.agree_tooltip {
    position: relative;
}
.my_tooltip {
    pointer-events: none;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    background: #f3385a;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10000;
    transition: opacity 0.5s ease-in-out;
    &::after {
        content: "";
        width: 15px;
        height: 15px;
        background: #f3385a;
        position: absolute;
        right: 10px;
        bottom: -3px;
        transform: rotate(45deg);
        border-radius: 3px;
    }
}
</style>
